import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { string, func, bool, shape, node, number } from 'prop-types';
import classNames from 'classnames';
import { LandownerProfile } from '@landtrustinc/design-system';
import { propTypes } from '../../util/types';
import { EarlyAccessModal } from '../../components';
import { hasPremiumMembership } from '../../util/user';
import { sanitizeHtml } from '../../util/sanitizeHtml';
import useHostProfile from '../../hooks/useHostProfile';

import css from './ListingPage.module.css';

const SectionHostMaybe = props => {
  const {
    listing,
    onContactUser,
    currentUser,
    fullProfile,
    className,
    isEarlyAccess,
    rootClassName,
    showRate,
    isContactDisabled,
    intl,
    noBackground,
    earlyAccessTimer,
  } = props;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const isPremium = hasPremiumMembership(currentUser);

  const { hostData, featureReviewItem } = useHostProfile({
    listing,
    showRate,
    intl,
  });

  if (!hostData) {
    return null;
  }

  const {
    displayName,
    bio,
    hostingSince,
    avatarSrc,
    isVerified,
    firstName,
    responseRate,
    responseTime,
  } = hostData;

  const handleMessageClick = () => {
    if (isEarlyAccess && !isPremium) {
      setIsModalOpen(true);
    } else {
      onContactUser(listing.author);
    }
  };

  const classes = classNames(rootClassName || css.root, className);

  return (
    <>
      <EarlyAccessModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <div className={classes}>
        <div id={fullProfile && 'host'} className={css.sectionHost}>
          <LandownerProfile
            avatarSrc={avatarSrc}
            // LandownerProfile renders bio as raw HTML, so sanitize it first.
            bio={fullProfile ? sanitizeHtml(bio) : null}
            heading={
              fullProfile ? intl.formatMessage({ id: 'SectionHostMaybe.meetTheLandowner' }) : null
            }
            isVerified={isVerified}
            messageButtonText={intl.formatMessage(
              { id: 'ListingPage.contactLandowner' },
              { name: firstName }
            )}
            name={displayName}
            onMessageClick={handleMessageClick}
            featureReviewItem={fullProfile ? featureReviewItem : null}
            responseRate={responseRate}
            responseTime={responseTime}
            hostingSince={hostingSince || undefined}
            isMessageDisabled={isContactDisabled || (isEarlyAccess && !isPremium)}
            className={noBackground ? css.hostProfile : null}
            earlyAccessTimer={earlyAccessTimer}
          />
        </div>
      </div>
    </>
  );
};

SectionHostMaybe.defaultProps = {
  fullProfile: null,
  currentUser: null,
  className: null,
  rootClassName: null,
  showRate: false,
  isEarlyAccess: false,
  isContactDisabled: false,
  noBackground: false,
  earlyAccessTimer: null,
};

SectionHostMaybe.propTypes = {
  className: string,
  listing: propTypes.listing.isRequired,
  onContactUser: func.isRequired,
  currentUser: propTypes.currentUser,
  fullProfile: bool,
  rootClassName: string,
  showRate: bool,
  isEarlyAccess: bool,
  isContactDisabled: bool,
  noBackground: bool,
  earlyAccessTimer: shape({
    expirationTimestamp: string,
    labelText: node,
    descriptionText: string,
    totalDuration: number,
  }),
};

export default injectIntl(SectionHostMaybe);
